module.exports = __webpack_public_path__ + "img/luisdtorresp.dd2799f3.jpg";